<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">
    <strong>{{ modalTitle }}</strong>
  </h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <div class="panel-body">
    
    <!-- Radio Button Selection -->
    <div style="text-align: center; width: 70%; margin-left: 15%;">
      <table>
        <tr>
          <td>
            <label>
              <input type="radio" 
                     [value]="true" 
                     [(ngModel)]="formData.panel"
                     name="panelRadio">
              Creditable Tax
            </label>
          </td>
          <td class="col-md-5">&nbsp;</td>
          <td>
            <label>
              <input type="radio" 
                     [value]="false" 
                     [(ngModel)]="formData.panel"
                     name="panelRadio">
              TB Amount Not Creditable
            </label>
          </td>
        </tr>
        <tr><td><br></td><td></td></tr>
      </table>
    </div>

    <!-- Creditable Tax Panel -->
    @if (formData.panel) {
<div>
      <div>
        <table class="table table-striped blue custom-table" style="text-align: left; width: 100%;">
          <thead>
            <tr>
              <th colspan="5" style="text-align: center;">Creditable Tax</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="col-md-2"></td>
              <td style="text-align: center;">
                <a href="javascript:void(0)" (click)="redirectUrl()">Go to FSI Sourcing</a>
              </td>
              <td class="col-md-2"></td>
              <td>Withholding Tax per Trial Balance</td>
              <td>
                <input type="text" 
                       class="form-control custom-textbox" 
                       style="height: 30px; width: 280px;"
                       [ngModel]="formData.withHoldTaxTrailBalanceAmt"
                       name="withHoldTaxTrailBalanceAmt"
                       disabled>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>Total Withholding Tax</td>
              <td>
                <input type="text" 
                       class="form-control custom-textbox" 
                       style="height: 30px; width: 280px;"
                       [ngModel]="formData.totalWithHoldTaxAmt"
                       name="totalWithHoldTaxAmt"
                       disabled>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td>Unreconciled Amt</td>
              <td>
                <input type="text" 
                       class="form-control custom-textbox" 
                       style="height: 30px; width: 280px;"
                       [ngModel]="formData.withHoldVarianceTaxAmt"
                       name="withHoldVarianceTaxAmt"
                       disabled>
              </td>
            </tr>
            <tr>
              <td class="col-md-2"></td>
              <td class="col-md-2"></td>
              <td class="col-md-2"></td>
              <td>Identify Total Withholding Tax on Dividend</td>
              <td>
                <input type="text" 
                       class="form-control custom-textbox" 
                       style="height: 30px; width: 280px;"
                       [(ngModel)]="formData.whTaxOnDividend"
                       name="whTaxOnDividend"
                       (keyup)="whTaxOnDividendAmount($event)"
                       (keydown)="$event.keyCode !== 69 ? true : false">
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Footer for Creditable Tax Panel -->
      <div class="modal-footer">
        <button class="save-button" 
                type="button" 
                (click)="saveCreditWHData()" 
                [disabled]="isSaveCredClicked">
          @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
        </button>
        <button class="reset-button" 
                type="button" 
                (click)="reset_credit()">
          Reset
        </button>
        <button class="cancel-button" 
                type="button" 
                (click)="cancel()">
          Cancel
        </button>
      </div>
      <br><br>
    </div>
}

    <!-- TB Amount Not Creditable Panel -->
    @if (!formData.panel) {
<div>
      <div>
        <table class="table table-striped blue custom-table" style="text-align: left; width: 100%;">
          <thead>
            <tr>
              <th colspan="5" style="text-align: center;">TB Amount Not Creditable</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Standard Reason Amount is Not Creditable</td>
              <td>
                <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="stdReasonCodeOptionsView"
  [selectType]="'single'" [title]="'Standard Reason'" [hideTitleOnInput]="true" [inputAriaLabel]="'Standard Reason'"
  [(ngModel)]="formData.selectStdReasonCdItem"
  (onSelect)="onIsTaxPriorYearFromDropdown($event)">
  @for (item of stdReasonCodeOptionsView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Standard Reason')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
              </td>
              <td></td>
              <td>Applicable Year</td>
              <td>
                <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="taxYearOptionsView"
  [selectType]="'single'" [title]="'Applicable Year'" [hideTitleOnInput]="true" [inputAriaLabel]="'Applicable Year'"
  [(ngModel)]="formData.applicableYearKeyItem"
  (onSelect)="onFormDataApplicableYearKeySelect($event)">
  @for (item of taxYearOptionsView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Applicable Year')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
              </td>
            </tr>
            <tr>
              <td>Amount</td>
              <td>
                <input type="number" 
                       class="form-control custom-textbox" 
                       [(ngModel)]="formData.nonCrdAmount" 
                       name="nonCrdAmount" 
                       style="height: 30px; width: 380px;">
              </td>
              <td></td>
              <td>Unreconciled Amt</td>
              <td>
                <input type="text" 
                       class="form-control custom-textbox" 
                       [ngModel]="formData.openVariance" 
                       name="openVariance" 
                       style="height: 30px; width: 380px;"
                       disabled>
              </td>
            </tr>

            <!-- Trading Partner Row (shown for Section Reduction Tax) -->
            @if (formData.isSectionReductionTax) {
<tr>
              <td>Trading Partner</td>
              <td colspan="4">
                <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="tradingPartnerOptionsView"
  [selectType]="'single'" [title]="'Trading Partner'" [hideTitleOnInput]="true" [inputAriaLabel]="'Trading Partner'"
  [showSearchbox]="true"
  [(ngModel)]="selectedTradingPartnerCodeItem"
  (onSelect)="onChangeTradingPartnerFromDropdown($event)">
  @for (item of tradingPartnerOptionsView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Trading Partner')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
              </td>
            </tr>
}

            <!-- Basket and Country Row (shown for Section 909 Splitter Tax or Section Reduction Tax) -->
            @if (formData.isSection909SplitrTax || formData.isSectionReductionTax) {
<tr>
              <td>Basket</td>
              <td>
                <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="basketOptionsView"
  [selectType]="'single'" [title]="'Basket'" [hideTitleOnInput]="true" [inputAriaLabel]="'Basket'"
  [(ngModel)]="formData.selectedSplitterBasketCatgItem"
  (onSelect)="onFormDataSelectedSplitterBasketCatgSelect($event)">
  @for (item of basketOptionsView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Basket')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
              </td>
              <td></td>
              <td>Country</td>
              <td>
                <ap-dropdown class="ftc-form-dropdown field-full-width" [list]="countryOptionsView"
  [selectType]="'single'" [title]="'Country'" [hideTitleOnInput]="true" [inputAriaLabel]="'Country'"
  [showSearchbox]="true"
  [(ngModel)]="selectedCountryCodeItem"
  (onSelect)="onChangeCountryFromDropdown($event)">
  @for (item of countryOptionsView; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setFormDropdownAriaLabel(item, 'Country')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
              </td>
            </tr>
}

            <tr>
              <td>Detailed Reason Amount is Not Creditable</td>
              <td>
                <textarea class="form-control custom-textbox" 
                          name="detailReason"
                          [(ngModel)]="formData.detailReason" 
                          style="height: 50px; width: 380px; overflow: scroll; resize: vertical;" 
                          maxlength="498"></textarea>
                <label style="font-weight: normal; font-size: x-small; color: gray;">Max length 500</label>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Footer for Non-Creditable Panel (hidden when ReturnAsFiled) -->
      @if (!formData.ReturnAsFiled) {
<div class="modal-footer">
        <button class="save-button" 
                type="button" 
                (click)="saveNonCreditWHData()" 
                [disabled]="isSaveClicked">
          @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
        </button>
        <button class="reset-button" 
                type="button" 
                (click)="reset()">
          Reset
        </button>
        <button class="cancel-button" 
                type="button" 
                (click)="cancel()">
          Cancel
        </button>
      </div>
}
      <br><br>

      <!-- Non-Creditable Records Table -->
      @if (nonCreditableRecords.length > 0) {
<div>
        <table class="table custom-table" style="text-align: left; table-layout: fixed;">
          <thead>
            <tr>
              <th width="5%"></th>
              <th width="5%"></th>
              <th width="20%">Standard Reason Amount is Not Creditable</th>
              <th width="15%">Applicable Year</th>
              <th width="15%">Amount</th>
              <th>Detailed Reason</th>
            </tr>
          </thead>
          <tbody>
            <!-- Data rows -->
            @if (!formData.tabular) {

              @for (t of nonCreditableRecords; track trackByTagKey(i, t); let i = $index) {
<tr>
                <td>
                  @if (!formData.ReturnAsFiled) {
<i style="font-size: 24px; cursor: pointer;"
                     class="fa fa-minus-circle color-red"
                     title="Remove Tax Amount"
                    
                     (click)="deleteRow(t)"></i>
}
                </td>
                <td>
                  @if (!formData.ReturnAsFiled) {
<i style="font-size: 18px; margin-left: 1px; cursor: pointer;"
                     class="glyphicon glyphicon-pencil"
                     title="Edit Tax Amount"
                    
                     (click)="editNonCreditableTaxRow(t)"></i>
}
                </td>
                <td>{{ t.STANDARD_REASON_NOT_CREDITABLE }}</td>
                <td>{{ t.APPLICABLE_YEAR }}</td>
                <td [ngClass]="{'color-red': t.NON_CREDIT_AMT < 0}">{{ t.NON_CREDIT_AMT | number }}</td>
                <td style="word-wrap: break-word">{{ t.DETAIL_REASON_NOT_CREDITABLE }}</td>
              </tr>
}
            
}
            
            <!-- Loading spinners row -->
            @if (formData.tabular) {
<tr>
              <td><i class="fa fa-spinner fa-pulse fa-lg"></i></td>
              <td><i class="fa fa-spinner fa-pulse fa-lg"></i></td>
              <td><i class="fa fa-spinner fa-pulse fa-lg"></i></td>
              <td><i class="fa fa-spinner fa-pulse fa-lg"></i></td>
              <td><i class="fa fa-spinner fa-pulse fa-lg"></i></td>
              <td><i class="fa fa-spinner fa-pulse fa-lg"></i></td>
            </tr>
}
          </tbody>
        </table>
      </div>
}
    </div>
}

  </div>
</div>

<!-- Delete Confirmation Modal -->
@if (showDeleteModal) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="deleteModalConfig"
    [visible]="false"
    (confirmed)="onDeleteConfirm()"
    (cancelled)="onDeleteCancel()"
    (closed)="onDeleteCancel()">
  </gtw-confirmation-modal>
</div>
}
